// Card component override
export default function Card(theme: any) {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          boxShadow: theme.shadows[1],
          border: '1px solid',
          borderColor: theme.palette.divider
        }
      }
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          padding: '24px'
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '24px'
        }
      }
    }
  };
}
